import { sheetToAbc } from '@ezchops/musicsheet';
import React, { useMemo } from 'react';
import AbcSheet, { InlineAbcSheet } from './AbcSheet';
export function MusicSheetSVG(props) {
    const { sheet, showSticking, style, multiVoice, useRepeats } = props;
    const [voices, unitNoteLength] = useMemo(() => {
        if (multiVoice) {
            const [hands, unitNoteLength] = sheetToAbc(sheet, useRepeats, 'hands');
            const [feet,] = sheetToAbc(sheet, useRepeats, 'feet');
            const [sticking,] = sheetToAbc(sheet, useRepeats, 'sticking');
            return [{ hands, feet, sticking: showSticking ? sticking : undefined }, unitNoteLength];
        }
        else {
            const [voice, unitNoteLength] = sheetToAbc(sheet, useRepeats);
            return [voice, unitNoteLength];
        }
    }, [multiVoice, sheet, showSticking, useRepeats]);
    return React.createElement(AbcSheet, { voice: voices, unitNoteLength: unitNoteLength, debug: props.debug, signature: sheet.segments[0].signature, position: props.position, sheetStyle: style });
}
export function InlineMusicSheetSVG(props) {
    const { sheet, showSticking, style, multiVoice, useRepeats } = props;
    const [voices, unitNoteLength] = useMemo(() => {
        if (multiVoice) {
            const [hands, unitNoteLength] = sheetToAbc(sheet, useRepeats, 'hands');
            const [feet,] = sheetToAbc(sheet, useRepeats, 'feet');
            const [sticking,] = sheetToAbc(sheet, useRepeats, 'sticking');
            return [{ hands, feet, sticking: showSticking ? sticking : undefined }, unitNoteLength];
        }
        else {
            const [voice, unitNoteLength] = sheetToAbc(sheet, useRepeats);
            return [voice, unitNoteLength];
        }
    }, [multiVoice, sheet, showSticking, useRepeats]);
    return React.createElement(InlineAbcSheet, { voice: voices, unitNoteLength: unitNoteLength, signature: sheet.segments[0].signature, sheetStyle: style });
}
//# sourceMappingURL=MusicSheetSVG.js.map